export enum DropShipFieldKeys {
  AlternativeAddressTitleType = 'alternativeAddressTitleType',
  RecipientName = 'recipientName',
  RecipientAddress = 'recipientAddress',
  RecipientSecondaryAddress = 'recipientSecondaryAddress',
  RecipientEmail = 'recipientEmail',
  RecipientPhone = 'recipientPhone',
  ZipCode = 'zip',
  City = 'city',
  Country = 'country',
  CountryState = 'countryState',
  ConfirmText = 'confirmText',
}
